import { Injectable } from '@angular/core';
import {State, Action, StateContext, Selector} from '@ngxs/store';
import {storeMedicationAction} from './ermedications.action'
export class storeMedicationModel{
    medicationData:any;
    
 }
 @State<storeMedicationModel>({
     name: 'medicationobj',
     defaults: {
        medicationData:null
      }
 })
 @Injectable()
 export class storeMedicationState {
 
     constructor( ) {
     }
 
     @Selector()
     static getMedication(state: storeMedicationModel) {
         return state;
     }
     @Action(storeMedicationAction)
     storeMedicationAction({getState, patchState}: StateContext<storeMedicationModel>, {payload}: storeMedicationAction) {
         const state = getState();
         patchState({
            medicationData:payload
         });
     }
    } 